/**
 * CosturiPersonalTab - Container cu sub-tab-uri
 * Sub-tab-uri: Centralizator | Medicina Muncii | Prime și Cadouri | Protecția Muncii | Alte Cheltuieli
 */
import { useState, memo } from 'react';
import CosturiCentralizator from './costuri/CosturiCentralizator';
import CheltuieliGrid from './costuri/CheltuieliGrid';
import { Table2, HeartPulse, Gift, ShieldCheck, MoreHorizontal, Award } from 'lucide-react';

const SUB_TABS = [
  { id: 'centralizator', label: 'Centralizator', icon: Table2 },
  { id: 'bonusare', label: 'Bonusare', icon: Award, apiPath: 'cheltuieli/bonusare', title: 'Bonusare', testIdPrefix: 'bonusare' },
  { id: 'medicina', label: 'Medicina Muncii', icon: HeartPulse, apiPath: 'medicina-muncii', title: 'Medicina Muncii', testIdPrefix: 'medicina' },
  { id: 'prime', label: 'Prime și Cadouri', icon: Gift, apiPath: 'cheltuieli/prime_cadouri', title: 'Prime și Cadouri', testIdPrefix: 'prime' },
  { id: 'protectia', label: 'Protecția Muncii', icon: ShieldCheck, apiPath: 'cheltuieli/protectia_muncii', title: 'Protecția Muncii', testIdPrefix: 'protectia' },
  { id: 'alte', label: 'Alte Cheltuieli', icon: MoreHorizontal, apiPath: 'cheltuieli/alte_cheltuieli', title: 'Alte Cheltuieli', testIdPrefix: 'alte' },
];

const CosturiPersonalTab = memo(function CosturiPersonalTab({ token }) {
  const [activeSubTab, setActiveSubTab] = useState('centralizator');

  const activeTab = SUB_TABS.find(t => t.id === activeSubTab);

  return (
    <div className="space-y-4" data-testid="costuri-personal-tab">
      {/* Sub-tab navigation */}
      <div className="flex gap-1 bg-slate-100 rounded-lg p-1 overflow-x-auto">
        {SUB_TABS.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveSubTab(tab.id)}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-colors whitespace-nowrap ${
                activeSubTab === tab.id
                  ? 'bg-white text-blue-600 shadow-sm'
                  : 'text-slate-500 hover:text-slate-700'
              }`}
              data-testid={`costuri-subtab-${tab.id}`}
            >
              <Icon className="w-3.5 h-3.5" />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Sub-tab content */}
      {activeSubTab === 'centralizator' && <CosturiCentralizator token={token} />}
      {activeTab?.apiPath && (
        <CheltuieliGrid
          key={activeSubTab}
          token={token}
          apiPath={activeTab.apiPath}
          title={activeTab.title}
          testIdPrefix={activeTab.testIdPrefix}
        />
      )}
    </div>
  );
});

export default CosturiPersonalTab;
